import { useApprovalText } from '@/hooks/useApprovelText';
import { cn } from '@/utils/cn';

export const ApprovalText = ({ withPadding = true }: { withPadding?: boolean }) => {
  const { footerText } = useApprovalText();

  // No configured legal text → render nothing (prevents an empty padded
  // block, e.g. an orphaned gap in the footer when no disclaimer is set).
  if (!footerText.trim()) {
    return null;
  }

  return (
    <div
      className={cn(
        // Cap at the same max-width as the payment content column above
        // (`paymentInnerStack` → `md:max-w-90`) so the legal text wraps in the
        // same column on desktop. Mobile keeps full-width (the footer's px-4
        // already matches the content's mx-4 inset), so the cap is `md:` only.
        'w-full md:max-w-90 md:mx-auto flex items-center justify-center text-center text-muted-foreground text-[10px] leading-4',
        withPadding && 'pt-[18px]'
      )}
    >
      <span className="inline approval-footer-text" dangerouslySetInnerHTML={{ __html: footerText }}></span>
    </div>
  );
};
